/**
 * Module dependencies.
 */

import { Description } from 'components/atoms/description/description';
import styled from '@emotion/styled';

/**
 * Export `ContactsDescription` styled component.
 */

export const ContactsDescription = styled(Description)`
  max-width: 680px;
  margin: 0 auto;
  margin-top: 24px;
  text-align: center;
`;

/**
 * Export `ContactsSection` styled component.
 */

export const ContactsSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 64px;
  gap: 64px;
  padding: 0 10%;

  @media (max-width: 1200px) {
    gap: 48px;
  }

  @media (max-width: 992px) {
    gap: 32px;
    flex-direction: column;
    padding: 0 10%;
  }

  @media (max-width: 768px) {
    gap: 24px;
  }

  @media (max-width: 620px) {
    gap: 16px;
    padding: 0;
  }
`;
